module.exports = __webpack_public_path__ + "img/gty_rm@2x.2d89e54b.png";